import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { 
  AddMemberComponent, 
  AddDependentComponent, 
  UpdateMemberComponent,
  UpdateCoverageComponent, 
  UpdateCoverageDetailsDialogComponent,
  UpdateContactInfoComponent,
  UpdateAddressInfoDialogComponent,
  UpdateContactInfoDialogComponent,
  CapDeductibleMoopComponent,
  AddMemberResponseDialogComponent,
  PharmacySearchComponent,
  PharmacyDetailsComponent,
  ClaimSearchDetailComponent,
  ClaimSearchCompareComponent,
  DrugPricingComponent,
  PrintIdCardComponent,
  DrugDetailsComponent,
  RequestClaimsDataDialogComponent,
  MailOrdersComponent,
  PrescriptionsComponent,
  MailOrderDetailsDialogComponent,
  PrescriptionDetailsDialogComponent,
  MemberSearchComponent,
  ExplanationOfBenefitsComponent,
  ApplyCardholderFutureCoverageDialog
} from '../online-eligibility';
import { GoogleMapsComponent, MaterialModule } from '@core';
import { SharedModule } from '@shared';
@NgModule({
  declarations: [
    MemberSearchComponent,
    AddMemberComponent,
    AddDependentComponent,
    UpdateMemberComponent,
    UpdateCoverageComponent,
    UpdateCoverageDetailsDialogComponent,
    UpdateContactInfoComponent,
    UpdateAddressInfoDialogComponent,
    UpdateContactInfoDialogComponent,
    CapDeductibleMoopComponent,
    AddMemberResponseDialogComponent,
    PharmacySearchComponent,
    PharmacyDetailsComponent,
    ClaimSearchDetailComponent,
    ClaimSearchCompareComponent,
    DrugPricingComponent,
    PrintIdCardComponent,
    DrugDetailsComponent,
    RequestClaimsDataDialogComponent,
    MailOrdersComponent,
    PrescriptionsComponent,
    MailOrderDetailsDialogComponent,
    PrescriptionDetailsDialogComponent,
    ExplanationOfBenefitsComponent,
    ApplyCardholderFutureCoverageDialog
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatAutocompleteModule,
    NgxMatSelectSearchModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    ClipboardModule,
    GoogleMapsModule,
    GoogleMapsComponent
  ],
  providers: [],
})
export class OnlineEligibilityModule { }
